/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de corridas.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmCorridas from "../../../catalogos/corridas/FrmCorridas.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmCorridasPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmCorridas">
      <FrmCorridas />
    </SizeSoftXFrmPortatil>
  );
}
